
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/availability",
      function () {
        return require("private-next-pages/availability/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/availability"])
      });
    }
  